import React, { useMemo } from 'react';
import Typography from '@material-ui/core/Typography';
import Section from 'components/content/section';
import SurveyQuestionCard from './question-card';
import surveyQuestions from '../../data-shapers/survey-questions';

export default function StudentPromptsSection({ tickets, isLoading }) {
  const questions = useMemo(() => surveyQuestions(tickets, 'studentPrompts'), [
    tickets,
  ]);

  if (isLoading) {
    return (
      <Section title="Pre-interaction prompts">
        <Typography>
          <em>Loading data...</em>
        </Typography>
      </Section>
    );
  } else if (questions.length === 0) {
    return (
      <Section title="Pre-interaction prompts">
        <Typography>
          <em>No data to display.</em>
        </Typography>
      </Section>
    );
  }

  return (
    <Section title="Pre-interaction prompts">
      <Typography paragraph>
        Students were asked these questions before requesting help at office
        hours.
      </Typography>

      {questions.map(({ question, responses, key }) => (
        <SurveyQuestionCard
          question={question}
          responses={responses}
          ticketCount={tickets.length}
          key={key}
        />
      ))}
    </Section>
  );
}
